import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Autocomplete, Paper, TextField } from "@mui/material";

import Button from "../../components/Button";
import { addOperation } from "../../api/operations";
import { getPositions } from "../../api/positions";
import "./index.scss";

const OperationsAdd = ({ history }) => {
  const { t } = useTranslation();
  const [operationName, setOperationName] = useState("");
  const [positions, setPositions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);

  const [operationErrorText, setOperationErrorText] = useState(null);
  const [positionsErrorText, setPositionsErrorText] = useState(null);

  useEffect(() => {
    (async () => {
      let newPositions = await getPositions();
      setPositions(newPositions);
    })();
  }, []);

  function handleOperationName(value) {
    setOperationName(value);
    if (!value) return setOperationErrorText(t("operations_page.operation_name_required"));
    setOperationErrorText(null);
  }

  function handleSelectedPositions(value) {
    setSelectedPositions(value);
    if (!value.length) return setPositionsErrorText(t("operations_page.positions_required"));
    setPositionsErrorText(null);
  }

  async function addNewOperation() {
    if (!selectedPositions.length) return handleSelectedPositions(selectedPositions);
    if (!operationName) return handleOperationName(operationName);

    const positionIdList = selectedPositions.map((position) => position.id);
    const result = await addOperation(operationName, positionIdList);
    if (result.ok) {
      history.push("/operations");
    }
  }

  return (
    <>
      <h2>{t("operations_page.add_title")}</h2>

      <Paper variant="outlined" className="add-operation" style={{ padding: "1rem 1.5rem" }}>
        <Autocomplete
          className="select-position"
          size="small"
          multiple
          options={positions}
          getOptionLabel={(position) => position.name}
          filterSelectedOptions
          onChange={(event, newPositions) => handleSelectedPositions(newPositions)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={`${t("position.select")}*`}
              size="small"
              error={!!positionsErrorText}
              helperText={positionsErrorText}
            />
          )}
        />
        <TextField
          className="add-field"
          variant="outlined"
          size="small"
          label={t("operations_page.operation_name_required_label")}
          value={operationName}
          onChange={(event) => handleOperationName(event.target.value)}
          error={!!operationErrorText}
          helperText={operationErrorText}
        />
        <Button title={t("operations_page.add_action")} onClick={addNewOperation}>
          {t("operations_page.add_operation")}
        </Button>
        <Button title={t("navigate_back")} onClick={() => history.goBack()}>
          {t("cancel")}
        </Button>
      </Paper>
    </>
  );
};

export default OperationsAdd;
